import map from 'lodash/map';

import {
  HomeContentsContentApi,
  HomeContentsApi,
  HomeCharityOutreachesListApi,
} from '@project/services';
import {
  HomeCharityOutreachesListModelType,
  HomeContentsContentModelType,
  HomeContentsModelType,
} from './types';

const HomeContentsContentModel = (data?: HomeContentsContentApi): HomeContentsContentModelType => ({
  id: data?.id ?? -1,
  link: data?.link ?? '',
  heading: data?.heading ?? '',
  subHeading: data?.sub_heading ?? '',
  buttonType: data?.button_type ?? '',
  featureImage: data?.feature_image ?? '',
  entireWebsite: data?.entire_website ?? true,
});

export const HomeContentsModel = (data?: HomeContentsApi): HomeContentsModelType =>
  map(data ?? [], (content) => HomeContentsContentModel(content));

export const HomeCharityOutreachesModel = (
  data?: HomeCharityOutreachesListApi,
): HomeCharityOutreachesListModelType => {
  return map(data ?? [], (item) => ({
    id: item.id,
    name: item.name,
    description: item.description,
    featureImage: item.feature_image,
  }));
};
